import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { Router } from '@angular/router';

import * as moment from 'moment';
import { environment } from '@environments/environment';

import { AuthenticationService } from '@app/shared/services';
import { MensagemService } from '@app/shared/services/mensagem.service';
import { CensoService } from '@app/shared/services/censo.service';
import { MessagingService } from '@app/shared/services/messaging.service';
import { UtilService } from './../../shared/services/util.service';

import { Loading, LoginUsuario, Censo } from '@app/shared/models';

@Component({
  selector: 'app-entrar',
  templateUrl: './entrar.component.html',
  styleUrls: ['./entrar.component.scss']
})
export class EntrarComponent implements OnInit {

  carregar = new Loading();
  cliente = environment.cliente;
  censo: Censo;
  formLogin: FormGroup = new FormGroup({});
  dataAtual = moment(new Date(), 'YYYY-MM-DD');

  constructor(
    private auth: AuthenticationService,
    private censoService: CensoService,
    private formBuilder: FormBuilder,
    private mensagemService: MensagemService,
    private messagingService: MessagingService,
    private router: Router,
    private utilService: UtilService
  ) {
    moment.locale('pt-BR');

    this.formLogin = this.formBuilder.group({
      nome: [''],
      cpf: [null, [Validators.required, (control: AbstractControl) => this.utilService.validatorsCustomCPF(control)]],
      dataNascimento: [null, [Validators.required, (control: AbstractControl) => this.utilService.validatorsCustomData(control)]],
      nomeMae: [''],
      idCenso: this.cliente.censo_id,
      tokenFirebase: this.messagingService.getCurrentToken(),
      chaveInterna: [''],
      captcha: [null, Validators.required]
    });
  }

  ngOnInit() {
    this.validarConfiguracoes();
  }

  submitForm(): void {
    this.formLogin = this.utilService.verificarForm(this.formLogin);

    if (this.formLogin.invalid) {
      return this.mensagemService.avisoFormularioInvalido();
    }

    const dataNascimento = this.utilService.formatarDataPadraoHTML(this.formLogin.get('dataNascimento')?.value);

    if (this.censo.flagHabilitarBloqueio) {
      if (this.validarAcessoPorMesAniversario(dataNascimento)) {
        return this.mensagemService.avisoMensagemAlerta('Acesso bloqueado! Por favor, tente novamente no mês do seu aniversário.');
      }

      if (this.bloquearAcessoPorDataDeNascimento(dataNascimento)) {
        return this.mensagemService.avisoMensagemAlerta(this.censo.msgAcessoBloqueado);
      }
    }

    const loginUsuario: LoginUsuario = {
      ...this.formLogin.value,
      dataNascimento: dataNascimento,
      nome: (this.formLogin.get('nome')?.value).toUpperCase(),
      nomeMae: (this.formLogin.get('nomeMae')?.value).toUpperCase()
    }

    this.auth.login(loginUsuario, this.carregar).subscribe(() => {
      this.router.navigate(['/recadastramento/primeiro-passo/']);
    });
  }

  resolved(captchaResponse: string): void {
    this.captcha = captchaResponse;
  }

  onError(errorDetails: any): void {
    this.captcha = null;
  }

  private async validarConfiguracoes() {
    this.censo = this.censoService.retornarSessionStorage('censo');

    if (this.compararDataInicialCenso(this.censo?.dataInicio)) {
      this.mensagemService.avisoMensagemAlerta(this.censo?.msgCensoNaoIniciado || '');
      this.router.navigate(['']);
      return;
    }

    if (this.compararDataFinalCenso(this.censo?.dataFim)) {
      this.mensagemService.avisoMensagemAlerta(this.censo?.msgCensoFinalizado || '');
      this.router.navigate(['']);
      return;
    }

    if (this.censo?.loginNomeMae) {
      this.formLogin.get('nomeMae').setValidators(Validators.required);
    }

    if (this.censo?.loginNome) {
      this.formLogin.get('nome').setValidators(Validators.required);
    }
  }

  private compararDataInicialCenso(dataInicio: any): boolean {
    const dataInicioCenso = moment(dataInicio);
    return this.dataAtual.isBefore(dataInicioCenso);
  }

  private compararDataFinalCenso(dataFim: any): boolean {
    const dataFimCenso = moment(dataFim);
    return this.dataAtual.isAfter(dataFimCenso);
  }

  private validarAcessoPorMesAniversario(data: any): boolean {
    const dataNascimento = moment(data).year(this.dataAtual.year());
    return dataNascimento.isAfter(this.dataAtual, 'month');
  }

  private bloquearAcessoPorDataDeNascimento(dataNascimento: any): boolean {
    const DIA_BLOQUEIO = this.censo.diaBloqueio;
    const MES_BLOQUEIO = this.censo.mesBloqueio;

    const dataNascimentoMoment = moment(dataNascimento, 'YYYY-MM-DD');
    const dataBloqueio = moment().year(this.dataAtual.year()).month(dataNascimentoMoment.month()).add(MES_BLOQUEIO, 'month').date(DIA_BLOQUEIO);

    return this.dataAtual.isSameOrAfter(dataBloqueio);
  }

  get captcha(): string {
    return this.formLogin.value.captcha;
  }

  set captcha(value) {
    this.formLogin.get('captcha').setValue(value);
  }

}
